module.exports = __webpack_public_path__ + "static/img/bg_3.329f5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_3.png
// module id = H/wc
// module chunks = 2